import { AngularMaterialModule } from './shared/material.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ThemesModule } from './themes/themes.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { LoginPageComponent } from './modules/auth/pages/login-page/login-page.component';
import { ForgotPasswordComponent } from './modules/auth/pages/forgot-password/forgot-password.component';
import { LoginFormComponent } from './modules/auth/components/login-form/login-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { LandingPageComponent } from './modules/sidebar-views/pages/landing-page/landing-page.component';
import { ResetPasswordComponent } from './modules/auth/pages/reset-password/reset-password.component';
import { SwitchUwModalComponent } from './modules/auth/modals/switch-uw-modal/switch-uw-modal.component';
import { UnauthorizedResponseInterceptor } from './core/interceptors/unauthorized-response.interceptor';
import { ChangePasswordComponent } from './modules/auth/pages/change-password/change-password.component';
import {
  LanguageSelectorModule,
  ProfileInformationDialogModule,
} from './shared/components';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HelpDeskComponent } from './help-desk/help-desk.component';
import { FaqsComponent } from './faqs/faqs.component';
import { NgZorroAntdModule } from './shared/nz-module';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { AuthPagesResolver } from './modules/auth/resolvers/auth-pages.resolver';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup

import { HtmlEditorModule } from './shared/components/html-editor/html-editor.component';
import { environment } from '@uw-env/environment';
import { ChangePasswordFormComponent } from './modules/auth/components/change-password-form/change-password-form.component';
import { PasswordRegistrationComponent } from './shared/components/password-registration/password-registration.component';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
registerLocaleData(localeFr, 'fr');

@NgModule({ declarations: [AppComponent], bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        ThemesModule,
        SharedModule,
        AngularMaterialModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: (environment as any).enableServiceWorker ?? environment.production }),
        NgZorroAntdModule,
        CoreModule,
        TranslateModule,
        BrowserAnimationsModule,
        ProfileInformationDialogModule,
        MatDialogModule,
        LanguageSelectorModule,
        PasswordRegistrationComponent,
        NgIdleKeepaliveModule.forRoot(),
        HtmlEditorModule, LoginPageComponent,
        ForgotPasswordComponent,
        LoginFormComponent,
        LandingPageComponent,
        ResetPasswordComponent,
        SwitchUwModalComponent,
        ChangePasswordFormComponent,
        ChangePasswordComponent,
        HelpDeskComponent,
        FaqsComponent], providers: [
        { provide: NZ_I18N, useValue: en_US },
        // CDK 21's native Popover-based overlay positioning drifts from its trigger on scroll (2692) — fall back to the legacy strategy.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, closeOnNavigation: false, autoFocus: 'dialog' } },
        AuthPagesResolver,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthorizedResponseInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
